/**
 * A regex object to validate URLs
 */
// export const ValidUrlRegex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:\/?#[\]@!\$&'\(?:\)\*\+,;=.]+$/gim;
export const URL_REGEX = /^(?:http(?:s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:\/?#[\]@!\$&'\(?:\)\*\+,;=.]+$/i;
